import { registerInstrumentations } from '@opentelemetry/instrumentation';
import {
  WebTracerProvider,
  ConsoleSpanExporter,
  SimpleSpanProcessor,
  BatchSpanProcessor,
} from '@opentelemetry/sdk-trace-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { CompositePropagator, W3CTraceContextPropagator } from '@opentelemetry/core';
import { B3Propagator, B3InjectEncoding } from '@opentelemetry/propagator-b3';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import {
  MeterProvider,
  PeriodicExportingMetricReader,
} from '@opentelemetry/sdk-metrics';

const resource = Resource.default().merge(
  new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: window.location.hostname + '-web',
    [SemanticResourceAttributes.SERVICE_VERSION]: '0.1.0',
  })
);

const collectorOptions = {
    url:  'https://collector.buupass.com/v1/traces', // url is optional and can be omitted - default is http://localhost:4318/v1/traces
    concurrencyLimit: 10, // an optional limit on pending requests
  };
  
  const exporter = new OTLPTraceExporter(collectorOptions);

const provider = new WebTracerProvider({
    resource,
    spanProcessors: [
      new BatchSpanProcessor(exporter, {
        maxQueueSize: 100,
        maxExportBatchSize: 10,
        scheduledDelayMillis: 500,
        exportTimeoutMillis: 30000,
      })
    ]
  });


// Use a CompositePropagator to send multiple header formats.
// This is the recommended approach for compatibility.
// It will send both W3C `traceparent` headers and B3 headers.
provider.register({
  propagator: new CompositePropagator({
    propagators: [
      new W3CTraceContextPropagator(), // Standard W3C Trace Context format
      new B3Propagator(),             // B3 single-header format (b3: ...)
      new B3Propagator({ injectEncoding: B3InjectEncoding.MULTI_HEADER }), // B3 multi-header format (X-B3-TraceId: ...)
    ],
  }),
});


registerInstrumentations({
  instrumentations: [
    getWebAutoInstrumentations({
      '@opentelemetry/instrumentation-document-load': {},
      '@opentelemetry/instrumentation-user-interaction': {},
      // --- THIS IS THE UPDATED SECTION ---
      // This configuration ensures that tracing headers are ONLY sent to your own backend domains.
      // It prevents CORS errors with third-party services like Zoho.
      '@opentelemetry/instrumentation-fetch': {
        propagateTraceHeaderCorsUrls: [
          /https?:collector.buupass.com/
        ],
        clearTimingResources: true,
      },  
      '@opentelemetry/instrumentation-xml-http-request': {
        propagateTraceHeaderCorsUrls: [
          /https?:collector.buupass.com/
        ],
        clearTimingResources: true,
      },
    }),
  ],
});

const metricReader = new PeriodicExportingMetricReader({
  exporter: new OTLPMetricExporter({
    url: 'https://collector.buupass.com/v1/metrics',
    headers: {},
  }),
  exportIntervalMillis: 6000,
});

// The MeterProvider is commented out, assuming this is intentional.
// If you need metrics, you would uncomment this section.
// const myServiceMeterProvider = new MeterProvider({
//   resource,
//   readers: [metricReader],
// });
// opentelemetry.metrics.setGlobalMeterProvider(myServiceMeterProvider);
